/* eslint-disable @typescript-eslint/naming-convention */
import type { Func } from "@react-awesome-query-builder/core";

const DATE_ADDITION: Func = {
  label: "DATE ADDITION",
  returnType: "date",
  jsonLogic: "DATE_ADDITION",
  sqlFunc: "DATE_ADDITION",
  args: {
    date: {
      label: "Date",
      type: "date",
      valueSources: ["value", "field", 'func'],
    },
    days: {
      label: "Days",
      type: "number",
      valueSources: ["value", "field", 'func'],
    },
  },
  formatFunc: (formattedArgs) =>
    `DATE_ADDITION(${formattedArgs.date},${formattedArgs.days})`,
  sqlFormatFunc: (formattedArgs) =>
    `DATE_ADDITION(${formattedArgs.date},${formattedArgs.days})`,
};

export default DATE_ADDITION;